import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { HeaderStore } from '../../../services/api/header/header-store.service';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ButtonComponent } from '../../feedback/button/button.component';
import { LoadingAnimationComponent } from '../../feedback/loading-animation/loading-animation.component';
import { ToFontSizePipe } from '../../../pipes/to-font-size/to-font-size.pipe';
import { ConfigurationStore } from '../../../services/api/configuration/configuration-store.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { TicketTypeToggleComponent } from '../../feedback/ticket-type-toggle/ticket-type-toggle.component';
import { DarkModeToggleComponent } from '../../feedback/dark-mode-toggle/dark-mode-toggle.component';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { HeaderInteractionService } from '../../../services/api/header/header-interaction.service';
import {
  CONFIGURATION_SETTING_KEYS,
  EEntityType,
  ERelationType,
} from '@web/dtos';
import { ERoute } from '../../../constants/routes.enum';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { RouterLink } from '@angular/router';
import { AuthProviderFactory } from '../../../services/auth/auth-provider.factory';
import { AuthProvider } from '../../../services/auth/auth.provider';
import { ShopLanguageDropDownComponent } from '../../data-input/shop-language-drop-down/shop-language-drop-down.component';
import { EConfigurationChannel } from '@web/dtos';

@Component({
  selector: 'aw-header',
  imports: [
    CommonModule,
    LanguagePipe,
    ButtonComponent,
    LoadingAnimationComponent,
    ToFontSizePipe,
    FilterTextsPipe,
    TicketTypeToggleComponent,
    DarkModeToggleComponent,
    RouterLink,
    ShopLanguageDropDownComponent,
  ],
  templateUrl: './header.component.html',
  styles: ``,
})
export class HeaderComponent {
  protected readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly headerStore: HeaderStore = inject(HeaderStore);
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly configStore: ConfigurationStore =
    inject(ConfigurationStore);
  protected readonly auth: AuthProvider =
    inject(AuthProviderFactory).getProvider('shop');
  protected readonly interactionService: HeaderInteractionService = inject(
    HeaderInteractionService
  );

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERoute: typeof ERoute = ERoute;

  public navigate(route: string): void {
    this.interactionService.navigate([route]);
  }

  public handleLoginButtonClick(): void {
    this.auth.login();
  }

  public logout(): void {
    this.auth.logout();
  }

  protected readonly CONFIGURATION_SETTING_KEYS: typeof CONFIGURATION_SETTING_KEYS =
    CONFIGURATION_SETTING_KEYS;
  protected readonly EConfigurationChannel: typeof EConfigurationChannel =
    EConfigurationChannel;
}
